(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lb-discount-code"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lb-discount-code')) {
    class LbDiscountCode extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === 'true') return;

        this.dataset.bound = 'true';
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="discount"]');
        this.button = this.querySelector('button[type="submit"]');
        this.message = this.querySelector('.lb-discount-code__message');

        this.form.addEventListener('submit', (event) => this.applyCode(event));
      }

      setMessage(text, state) {
        this.message.textContent = text;
        this.message.dataset.state = state;
      }

      async applyCode(event) {
        event.preventDefault();

        const code = this.input.value.trim();

        if (!code) {
          this.setMessage(this.dataset.empty, 'error');
          this.input.focus();
          return;
        }

        this.button.disabled = true;
        this.input.setAttribute('aria-busy', 'true');
        this.setMessage('', '');

        try {
          const root = window.Shopify?.routes?.root || '/';
          const beforeResponse = await fetch(root + 'cart.js', {
            headers: { Accept: 'application/json' }
          });
          const beforeCart = await beforeResponse.json();

          const response = await fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ discount: code })
          });

          if (!response.ok) throw new Error('Discount update failed');

          const cart = await response.json();
          const normalizedCode = code.toLowerCase();
          const titles = [
            ...(cart.cart_level_discount_applications || []).map((discount) => discount.title),
            ...(cart.items || []).flatMap((item) => (item.discounts || []).map((discount) => discount.title))
          ]
            .filter(Boolean)
            .map((title) => String(title).toLowerCase());

          const appliedByTitle = titles.includes(normalizedCode);
          const appliedBySavings =
            Number(cart.total_discount || 0) > Number(beforeCart.total_discount || 0) ||
            Number(cart.total_price || 0) < Number(beforeCart.total_price || 0);

          if (!appliedByTitle && !appliedBySavings) {
            this.setMessage(this.dataset.invalid, 'error');
            return;
          }

          this.setMessage(this.dataset.success, 'success');
          window.setTimeout(() => window.location.reload(), 350);
        } catch (error) {
          this.setMessage(this.dataset.error, 'error');
        } finally {
          this.button.disabled = false;
          this.input.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('lb-discount-code', LbDiscountCode);
  }
  } catch(e) { console.error(e); }
})();

})();
